import { useState, useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Navbar from "../components/Navbar/Navbar";
import VortexUserProfile from "./VortexUser/UserProfile";
import Sidebar from "../components/Sidebar/Sidebar";
import User from "./User/User";
import Content from "./Content/Content";
import Notifications from "./Notifications/Notifications";
import VortexNotification from "./VortexNotifications/Notifications";
import VortexAppManager from "./VotexAppManager/AppManager";
import UserProfile from "./User/UserProfile";
import Login from "./Login/Login";
import ForgotPassword from "./Login/forgot_password";
import DataAnalysis from "./DataAnalysis/DataAnalysis";
import Settings from "./Settings/Settings";
import Security from "./Security/Security";
import Reporting from "./Reporting/Reporting";
import AppManager from "./AppManager/AppManager";
import Email from "./Email/Email";
import VortexEmail from "./VortexEmail/Email";
import VortexDataAnalysis from "./VortexDataAnalysis/DataAnalysis";
import VortexUser from "./VortexUser/User";
import VortexSettings from "./VortexSettings/Settings";
import VortexSecurity from "./VortexSecurity/Security";
import VortexReporting from "./VortexReporting/Reporting";
import AccountReset from "./Login/accountReset";
import Register from "../register/Register";
import AdminManagement from "./AdminManagement/AdminManagement";
import PermissionRoute from "../PermissionRoute";
import { PERMISSIONS } from "../adminConfig";

const AuthorizedCom = () => {
  const { token } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("legacy");

  const handleTabChange = (tab) => {
    if (tab === "legacy") navigate("/");
    else if (tab === "vortex") navigate("/vortexData");
    setActiveTab(tab);
  };

  useEffect(() => {
    if (
      !token &&
      location.pathname !== "/login" &&
      location.pathname !== "/forgot-password" &&
      location.pathname !== "/admin-account-reset" &&
      location.pathname !== "/register"
    ) {
      navigate("/login");
    }
  }, [token, navigate, location.pathname]);

  const isAuthPage =
    location.pathname === "/login" ||
    location.pathname === "/forgot-password" ||
    location.pathname === "/admin-account-reset" ||
    location.pathname === "/register";

  if (isAuthPage) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/admin-account-reset" element={<AccountReset />} />
        <Route path="/register" element={<Register />} />
      </Routes>
    );
  }

  return (
    <div style={{ minHeight: "100vh", width: "100%", backgroundColor: "black" }}>

      {/* ✅ Navbar — fixed, gets hamburger click handler */}
      <Navbar
        tab={activeTab}
        changeTab={handleTabChange}
        onMenuClick={() => setMobileOpen(true)}
      />

      {/* ✅ Below navbar — flex row, sidebar + content */}
      <div style={{
        display: "flex",
        paddingTop: "72px",      // matches navbar height
        minHeight: "100vh",
        alignItems: "stretch",
      }}>

        {/* ✅ Sidebar — always rendered, manages its own desktop/mobile display */}
        <Sidebar
          mobileOpen={mobileOpen}
          setMobileOpen={setMobileOpen}
        />

        {/* ✅ Main content */}
        <main style={{
          flex: 1,
          overflowX: "hidden",
          backgroundColor: "black",
          minWidth: 0,  // prevents flex overflow
        }}>
          <Routes>
            {/* Dashboard — all logged-in users */}
            <Route path="/" element={token ? <DataAnalysis /> : <Navigate to="/login" />} />

            {/* User profiles */}
            <Route path="/userProfile/:userId"        element={<PermissionRoute permission={PERMISSIONS.READ_USERS}><UserProfile /></PermissionRoute>} />
            <Route path="/vortexuserProfile/:userId"  element={<PermissionRoute permission={PERMISSIONS.READ_USERS}><VortexUserProfile /></PermissionRoute>} />

            {/* LXDC routes */}
            <Route path="/user"             element={<PermissionRoute permission={PERMISSIONS.READ_USERS}       ><User /></PermissionRoute>} />
            <Route path="/content"          element={<PermissionRoute permission={PERMISSIONS.MANAGE_CONTENT}   ><Content /></PermissionRoute>} />
            <Route path="/notifications"    element={<PermissionRoute permission={PERMISSIONS.VIEW_ANALYTICS}   ><Notifications /></PermissionRoute>} />
            <Route path="/AppManager"       element={<PermissionRoute permission={PERMISSIONS.MANAGE_SYSTEM}    ><AppManager /></PermissionRoute>} />
            <Route path="/appmanager"       element={<PermissionRoute permission={PERMISSIONS.MANAGE_SYSTEM}    ><AppManager /></PermissionRoute>} />
            <Route path="/Email"            element={<PermissionRoute permission={PERMISSIONS.MANAGE_CAMPAIGNS} ><Email /></PermissionRoute>} />
            <Route path="/email"            element={<PermissionRoute permission={PERMISSIONS.MANAGE_CAMPAIGNS} ><Email /></PermissionRoute>} />
            <Route path="/settings"         element={<PermissionRoute permission={PERMISSIONS.MANAGE_SYSTEM}    ><Settings /></PermissionRoute>} />
            <Route path="/security"         element={<PermissionRoute permission={PERMISSIONS.MANAGE_SYSTEM}    ><Security /></PermissionRoute>} />
            <Route path="/reporting"        element={<PermissionRoute permission={PERMISSIONS.VIEW_ANALYTICS}   ><Reporting /></PermissionRoute>} />
            <Route path="/admin-management" element={<PermissionRoute permission={PERMISSIONS.MANAGE_SYSTEM}    ><AdminManagement /></PermissionRoute>} />

            {/* Vortex routes */}
            <Route path="/vortexData"          element={<PermissionRoute permission={PERMISSIONS.VIEW_ANALYTICS}  ><VortexDataAnalysis /></PermissionRoute>} />
            <Route path="/vortexusers"         element={<PermissionRoute permission={PERMISSIONS.READ_USERS}      ><VortexUser /></PermissionRoute>} />
            <Route path="/vortexemail"         element={<PermissionRoute permission={PERMISSIONS.MANAGE_CAMPAIGNS}><VortexEmail /></PermissionRoute>} />
            <Route path="/vortexnotifications" element={<PermissionRoute permission={PERMISSIONS.VIEW_ANALYTICS}  ><VortexNotification /></PermissionRoute>} />
            <Route path="/vortexappmanager"    element={<PermissionRoute permission={PERMISSIONS.MANAGE_SYSTEM}   ><VortexAppManager /></PermissionRoute>} />
            <Route path="/vortexsettings"      element={<PermissionRoute permission={PERMISSIONS.MANAGE_SYSTEM}   ><VortexSettings /></PermissionRoute>} />
            <Route path="/vortexsecurity"      element={<PermissionRoute permission={PERMISSIONS.MANAGE_SYSTEM}   ><VortexSecurity /></PermissionRoute>} />
            <Route path="/vortexreporting"     element={<PermissionRoute permission={PERMISSIONS.VIEW_ANALYTICS}  ><VortexReporting /></PermissionRoute>} />

            {/* Unauthorized */}
            <Route path="/unauthorized" element={<Unauthorized />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

const Unauthorized = () => {
  const navigate = useNavigate();
  return (
    <div style={{
      display: "flex", flexDirection: "column", alignItems: "center",
      justifyContent: "center", height: "70vh", gap: "16px",
    }}>
      <div style={{ fontSize: "52px" }}>🔒</div>
      <div style={{ color: "white", fontSize: "20px", fontWeight: 700, fontFamily: "Gilroy, sans-serif" }}>
        Access Denied
      </div>
      <div style={{ color: "#6b7280", fontSize: "14px", fontFamily: "Gilroy, sans-serif" }}>
        You don't have permission to view this page.
      </div>
      <button
        onClick={() => navigate("/")}
        style={{
          marginTop: "8px", background: "#FF6B35", color: "white",
          border: "none", borderRadius: "8px", padding: "10px 24px",
          fontSize: "14px", fontFamily: "Gilroy, sans-serif",
          fontWeight: 700, cursor: "pointer",
        }}
      >
        Back to Dashboard
      </button>
    </div>
  );
};

export default AuthorizedCom;